export default "__VITE_ASSET__Bm6XVqAG__"